import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import React, { useContext, useState } from 'react';
import { translate } from '../../../../../types/translation/Translator';
import ContainerForm from './ContainerForm';
import { Breadcrumbs, ContainerOverviewCrumb, Crumb } from '../../../../components/Breadcrumbs';
import { Routing } from '../../../../../util/routes.util';
import { ContainerInput } from '../../../../../types/container';
import { CompanyContext } from '../../../../../context/CompanyContext';
import { CreateButton } from '../../../../components/Button';
import useMutation from '../../../../../hooks/useMutation';
import {
  ContainerMutations,
  CreateContainerResponse,
  CreateContainerVariables,
} from '../../../../../graphql/container.graphql';
import { ContainerContext } from '../../../../../context/ContainerContext';
import { useToast } from '../../../../../providers/ToastProvider';
import { ToastType } from '../../../../components/Toast';
import { CustomFieldContext } from '../../../../../context/CustomFieldContext';
import { useNavigate } from 'react-router-dom';

export default function CreateContainerScreen() {
  const navigate = useNavigate();
  const { showToast } = useToast();

  const { currentCompany } = useContext(CompanyContext);
  const { containers, setContainers } = useContext(ContainerContext);
  const { customFields } = useContext(CustomFieldContext);

  const [input, setInput] = useState(new ContainerInput({ companyId: currentCompany.id }));

  const [create, { loading }] = useMutation<CreateContainerResponse, CreateContainerVariables>(
    ContainerMutations.create,
    {
      onCompleted: response => {
        const created = response.createContainer[0];
        setContainers(new Map(containers.set(created.id, created)));
        showToast({
          type: ToastType.success,
          title: translate({ key: TranslationKey.containerCreatedSuccessfullyToastTitle }),
        });
        navigate(Routing.stock.containers.overview());
      },
    },
  );

  return (
    <div className='flex h-full flex-col'>
      <Breadcrumbs>
        <ContainerOverviewCrumb />
        <Crumb
          current
          path={Routing.stock.containers.create()}
          text={translate({ key: TranslationKey.createContainer })}
        />
      </Breadcrumbs>
      <div className='content-y-breadcrumbs content-x flex flex-grow flex-col gap-8'>
        <div className='grid gap-2'>
          <p className='page-title'>{translate({ key: TranslationKey.createContainerScreenTitle })}</p>
          <p className='subtitle'>{translate({ key: TranslationKey.createContainerScreenSubtitle })}</p>
        </div>
        <ContainerForm input={input} setInput={setInput} />
        <div>
          <CreateButton
            disabled={!input.validate(customFields)}
            onClick={() => create({ variables: { containers: [input.forCreate()] } })}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
}
